<template>
  <section class="quote full pad">
    <div class="foreground">
      <img :src="quote.authorImg" class="quote-image" v-animate-in />
      <h3 class="quote-description" v-animate-in="{ delay: 0.15 }">
        {{ quote.text[$i18n.locale] }}
      </h3>
      <p class="quote-author tx-wg-bold" v-animate-in="{ delay: 0.25 }">
        {{ quote.author[$i18n.locale] }}
      </p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Quote',
  props: {
    quote: {
      type: Object,
      default: () => {
        return {
          author: { it: '', en: '' },
          text: { it: '', en: '' },
          authorImg: ''
        };
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.quote {
  padding-bottom: $padding;
  &.pad {
    @media screen and (max-width: $mq-tablet) {
      padding-bottom: $padding/4;
      padding-top: $padding/2;
    }
  }
  position: relative;
  background-color: $col-red-light;
  @include centered(true, true, column);
  .foreground {
    position: relative;
    display: block;
    z-index: 2;
    width: 80%;
    @media screen and (max-width: $mq-tablet) {
      width: 100%;
    }
    .quote-image {
      width: 160px;
      display: inline-block;
      position: absolute;
      top: -9.75rem;
      left: -3.6rem;
      z-index: -1;
      @media screen and (max-width: $mq-tablet) {
        left: 0.2rem;
        top: -7rem;
        width: 120px;
      }
      @media screen and (max-width: $mq-mobile) {
        top: -5rem;
        width: 80px;
      }
      path {
        fill: $col-navy-dark;
      }
    }
    .quote-author {
      color: $col-navy-dark;
      margin-top: $padding / 2;
      @media screen and (max-width: $mq-mobile) {
        margin-top: $padding / 4;
      }
    }
  }
}
</style>
